// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1jy5t","signatureBlock":"Footer_signatureBlock__MgNv8","signature":"Footer_signature__2tiVh"};